const ENV_META = {
    local: { type: 'local' },
    development: { type: 'local' },

    dev: { type: 'test', name: 'dev' },
    qa: { type: 'test', name: 'qa' },
    uat: { type: 'test', name: 'uat', useQaLeagues: true },

    test1: { type: 'test', name: 'test1' },
    test2: { type: 'test', name: 'test2' },
    test3: { type: 'test', name: 'test3' },
    test4: { type: 'test', name: 'test4' },
    test5: { type: 'test', name: 'test5' },
    test6: { type: 'test', name: 'test6' },

    prod: { type: 'prod' },
    production: { type: 'prod' },
};

module.exports = { ENV_META };
